'use client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Suspense } from 'react';
const queryClient = new QueryClient();

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

export function ClientLayout({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback="loading...">
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </Suspense>
  );
}
